import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";

export const SET_LOADING = "saga/retention/xponentialPlus/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/retention/xponentialPlus/SET_UPDATES_LOADING";

export const SET_DATES = "saga/retention/SET_DATES";

export const UPDATE_DATES = "saga/retention/xponentialPlus/UPDATE_DATES";

export const FETCH_CURRENT_USER = "sagas/retention/xponentialPlus/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "sagas/retention/xponentialPlus/FETCH_CURRENT_USER_SUCCESS";

export const FETCH_FILTERS_SUCCESS = "sagas/retention/xponentialPlus/FETCH_FILTERS_SUCCESS";
export const FETCH_VALUES = "sagas/retention/xponentialPlus/FETCH_VALUES";

export const UPDATE_DATA = "sagas/retention/xponentialPlus/UPDATE_DATA";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateData: createAction(UPDATE_DATA)
};

export default function* watchIntroBreakdown() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_DATA, updateData);
}

function* setDates() {
  yield put({ type: SET_DATES });
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const { date } = yield select((state) => state.xponentialPlus);

  return { organization_id, short_url, date };
}

function* fetchCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield setDates();

  try {
    yield fetchValues();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchValues() {
  const params = yield getCommonApiParams();

  const baseUrl = queryParams.apiVersion + "pages/subscription_sales/xponential_plus/";
  try {
    const trials = yield call(axios.get, baseUrl + "trials", { params });
    const recurringRevenue = yield call(axios.get, baseUrl + "recurring_revenue", { params });
    const activePaying = yield call(axios.get, baseUrl + "active_paying_subscriptions", { params });
    const newMembers = yield call(axios.get, baseUrl + "new_subscriptions", { params });

    const dataPoints = {
      trials: trials.data,
      recurringRevenue: recurringRevenue.data,
      activePaying: activePaying.data,
      newMembers: newMembers.data
    };
    yield put({ type: FETCH_VALUES, payload: dataPoints });
  } catch (err) {
    console.error(err);
  }
}

function* updateData(data) {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_DATES, payload: data.payload });

  try {
    yield fetchValues();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}
